import { createMutation } from '../../libs/react-query';
import getConfig from 'next/config';
import { privateBookingModel } from './models';

const url = 'private-bookings';
const { publicRuntimeConfig } = getConfig();

export const useCreatePrivateBooking = createMutation<
  Partial<privateBookingModel>,
  privateBookingModel
>({
  method: 'post',
  url: url,
  headers: {
    'X-App-Version': publicRuntimeConfig?.version,
  },
});
